type GeoJsonGeometry = {
  type: string;
  coordinates: any;
};

type GeoJsonFeature = {
  geometry?: GeoJsonGeometry | null;
};

type GeoJsonFeatureCollection = {
  type?: string;
  features?: GeoJsonFeature[];
};

type LngLatTuple = readonly (number | undefined)[];

function isPointInRing(point: LngLatTuple, ring: LngLatTuple[]): boolean {
  const [x, y] = point;
  if (typeof x !== "number" || typeof y !== "number") {
    return false;
  }
  let isInside = false;

  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];
    if (
      typeof xi !== "number" ||
      typeof yi !== "number" ||
      typeof xj !== "number" ||
      typeof yj !== "number"
    ) {
      continue;
    }

    const intersects =
      yi > y !== yj > y &&
      x < ((xj - xi) * (y - yi)) / ((yj - yi) || Number.EPSILON) + xi;

    if (intersects) {
      isInside = !isInside;
    }
  }

  return isInside;
}

function isPointInPolygon(point: LngLatTuple, polygon: LngLatTuple[][]): boolean {
  if (polygon.length === 0) {
    return false;
  }

  if (!isPointInRing(point, polygon[0])) {
    return false;
  }

  for (let i = 1; i < polygon.length; i += 1) {
    if (isPointInRing(point, polygon[i])) {
      return false;
    }
  }

  return true;
}

export function isPointInGeoJson(point: LngLatTuple, geoJson: GeoJsonFeatureCollection | null | undefined): boolean {
  if (!geoJson?.features?.length) {
    return true;
  }

  return geoJson.features.some((feature) => {
    const geometry = feature.geometry;
    if (!geometry) {
      return false;
    }

    if (geometry.type === "Polygon") {
      return isPointInPolygon(point, geometry.coordinates as LngLatTuple[][]);
    }

    if (geometry.type === "MultiPolygon") {
      return (geometry.coordinates as LngLatTuple[][][]).some((polygon) =>
        isPointInPolygon(point, polygon)
      );
    }

    return false;
  });
}
